import { Button } from "@dropbox/dig-components/buttons";
import { Toggle } from "@dropbox/dig-components/controls";
import { FormLabel } from "@dropbox/dig-components/form_row";
import { Modal } from "@dropbox/dig-components/modal";
import { Text } from "@dropbox/dig-components/typography";
import { getCurrentBrowser } from "@mirage/shared/util/webExtensionsHelpers";
import i18n from "@mirage/translations";
import { useState } from "react";
import styles from "./DashAsNewTab.module.css";
import chromeGif from "./DashAsNewTabChrome.gif";
import safariGif from "./DashAsNewTabSafari.gif";
import { useExtensionSettings } from "./useExtensionSettings";

export const DashAsNewTab = () => {
  const extensionSettings = useExtensionSettings();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const isSafari = getCurrentBrowser() === "safari";
  const graphic = isSafari ? safariGif : chromeGif;
  const steps = isSafari
    ? [
        i18n.t("disable_dash_new_tab_tooltip_step_1_safari"),
        i18n.t("disable_dash_new_tab_tooltip_step_2_safari"),
        i18n.t("disable_dash_new_tab_tooltip_step_3_safari"),
      ]
    : [
        i18n.t("disable_dash_new_tab_tooltip_step_1"),
        i18n.t("disable_dash_new_tab_tooltip_step_2"),
        i18n.t("disable_dash_new_tab_tooltip_step_3"),
      ];

  return (
    <>
      {extensionSettings.available ? (
        <>
          <Toggle
            checked={extensionSettings.newTabEnabled}
            onChange={({ target: { checked } }) =>
              extensionSettings.setNewTabEnabled(checked)
            }
          />
          <FormLabel variant="control">
            {i18n.t(
              extensionSettings.newTabEnabled
                ? "settings_extension_on"
                : "settings_extension_off",
            )}
          </FormLabel>
        </>
      ) : (
        <Button variant="transparent" onClick={() => setIsModalOpen(true)}>
          {i18n.t("settings_extension_turn_off")}
        </Button>
      )}

      <Modal open={isModalOpen}>
        <Modal.FullBleed>
          <img
            src={graphic}
            alt={i18n.t("disable_dash_new_tab_tooltip_graphic_alt")}
          />
        </Modal.FullBleed>
        <Modal.Header>
          <Modal.Title size="small">
            {i18n.t("disable_dash_new_tab_tooltip_title")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Text color="faint">
            <ol className={styles.ol}>
              {steps.map((step) => (
                <li key={step}>{step}</li>
              ))}
            </ol>
          </Text>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setIsModalOpen(false)}>
            {i18n.t("got_it")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
